define([
    'common/ui/template/behavior/readmore.hbs',
    'backbone',
    'backbone.marionette'
], function(
    ReadMoreTemplate,
    Backbone
    ){
    return Backbone.Marionette.Behavior.extend({
        defaults: {
            showReadMore: function() {
                return false;
            },
            onReaMore: function() {},
            /**
             * true の場合さらに読む表示をリストの一番上に置く
             */
            placeTop: false
        },

        onAddChild: function() {
            this.renderReadmore();
        },

        onRenderChildren: function() {
            this.renderReadmore();
        },

        renderReadmore: function() {
            this.$('> .read-more').remove();
            var colView = null;
            if(this.view.childViewContainer) {
                if(_.isFunction(this.view.childViewContainer)) {
                    colView = this.$(this.view.childViewContainer());
                } else {
                    colView = this.$(this.view.childViewContainer);
                }
            } else {
                colView = this.$el;
            }
            if(_.bind(this.options.showReadMore, this.view)()) {
                var readMore = $(ReadMoreTemplate());

                if(this.options.placeTop) {
                    colView.prepend(readMore);
                } else {
                    colView.append(readMore);
                }

                readMore.on('click', _.bind(function(){
                    const readMoreReturn = _.bind(this.options.onReadMore, this.view)();
                    // onReadMore が Promise を返したときには、その処理を終えるタイミングで read-more を更新する
                    // (何も返さないときは諦める)
                    if (readMoreReturn) {
                        // "続きを読む" をクリックされたとき、 cursor を not-allowed に変更して..
                        this.$('> .read-more').css('cursor', 'not-allowed');
                        readMoreReturn.then(() => {
                            // 取得完了した時点で、続きがあるならば cursor を pointer に戻して、
                            // 続きが無ければ "続きを読む" DOM を削除する
                            if (_.bind(this.options.showReadMore, this.view)()) {
                                this.$('> .read-more').css('cursor', 'pointer');
                            } else {
                                this.$('> .read-more').remove();
                            }
                        });
                    }
                }, this));
            }
        }
    });
});



// WEBPACK FOOTER //
// ./common/ui/view/behavior/readmore.js